import React, {useState} from "react";
import SelectInput from "../../system/select";
import {getAgentsListWithPersonId} from "../../../services/agent/agent";
import {AgentServiceManagement} from "../../service/agent_service";
import {Typography} from "@material-tailwind/react";


export function BackOfficeAgentServiceManagement() {

  const [personId, setPersonId] = useState(null);

  return (
    <div className="flex flex-col w-full bg-white gap-4">

      <div className="mb-8 flex items-center justify-between mt-2">
        <Typography variant="h5" color="blue-gray">خدمات مشاوران</Typography>
      </div>

      <div className="flex flex-col mb-4 overflow-y-visible w-full md:w-1/2">
        <SelectInput
          label={"کاربر"}
          defaultValue={personId}
          refreshSignal={personId}
          // multiselect={false}
          autoLoadService={getAgentsListWithPersonId}
          autoLoadRender={({name, family, phone}) => {
            const fullName = `${name?.trim()} ${family?.trim()}`.trim();
            return fullName + " - " + phone
          }}
          onChange={setPersonId}
        />
      </div>

      {personId &&
        <AgentServiceManagement person_id={personId}/>
      }
    </div>
  );
}